import React, { useEffect } from "react";
import Container from "@material-ui/core/Container";
// import styled from 'styled-components'
import BuccaneerHeader from "../components/Home/BuccaneerHeader";
import TopContainer from "../components/Home/TopContainer";
import ItemList from "../components/Home/ItemList";
import ImageContainer from "../components/Home/ImageContainer";
import ImageContainer1 from "../components/Home/ImageContainer1";
import ImageContainer2 from "../components/Home/ImageContainer2";
import { useTranslation } from "react-i18next";

// import { colors } from "../styles";

import ethereum from "../assets/images/1.mp4";
import chain from "../assets/images/2.mp4";
import dot from "../assets/images/3.mp4";
import { useLocation } from "react-router-dom";
import { useStateContext } from "../providers/StateProvider";
import { LANGUAGE_TYPES } from "../constants/context";

interface Props {
  connect: () => void;
  setIsHide: (e: any) => void;
  killSession: () => void;
  isHide: boolean;
  connected: boolean;
  address: string;
  chainId: number;
}

// const WholeCard = styled.div`
//     width: 100%;
//     border: 1px solid rgba(${colors.border});
//     padding: 1em;
//     border-radius: 2em;
//     background-color: rgba(0, 0, 0, 0.6);
// `

const Home = (props: Props) => {
  const { t } = useTranslation();

  const { pathname } = useLocation();
  const { setLanguage } = useStateContext();

  useEffect(() => {
    const segments = pathname.split("/").filter((segment) => segment !== "");
    if (segments.length) {
      if (segments[0] === "cn") setLanguage(LANGUAGE_TYPES.CHINESE);
      else setLanguage(LANGUAGE_TYPES.ENGLISH);
    } else {
      setLanguage(LANGUAGE_TYPES.ENGLISH);
    }
  }, [pathname]);

  return (
    <Container maxWidth="lg">
      <BuccaneerHeader
        connect={props.connect}
        isHide={props.isHide}
        setIsHide={(e: any) => props.setIsHide(e)}
        connected={props.connected}
        address={props.address}
        chainId={props.chainId}
        killSession={props.killSession}
      />
      <TopContainer isHide={props.isHide} />
      <ItemList />
      <ImageContainer
        url={ethereum}
        title={t("FullyOnChain")}
        desc1={t("BuildingBV3")}
      />
      <ImageContainer1
        url={chain}
        title={t("ETHNotNeeded")}
        desc1={t("SendBUCCtokens")}
        desc2={t("AmongManyScenario")}
      />
      <ImageContainer2
        url={dot}
        title={t("PrivateIslandMoney")}
        desc1={t("FundingProblem")}
        desc2={t("TortugaSolves")}
        desc3={t("UtilityAfforded")}
      />
      {/* </WholeCard> */}
    </Container>
  );
};

export default Home;
